import { Stripe, loadStripe } from '@stripe/stripe-js';
import { environment } from '@env/environment';

export function stripeInit(): void {
  loadStripe(environment.stripePk).then((stripe: Stripe) => {
    window['stripe'] = stripe;
  });
}
